<template>
  <div class="d-flex" style="position: relative">
    <v-text-field
      outlined
      v-model="money"
      :label="model.title"
      :error-messages="error"
      :disabled="isDisable"
      :hide-details="config.hideDetails || false"
      :dense="config.dense || false"
      :readonly="config.readonly || false"
      inputmode="numeric"
      @keypress="filter($event)"
      @focus="indicatorChange = true"
      @blur="indicatorChange = false"
    />
    <btn-rating v-if="(model.rating && config.rating) || false" v-model="rating"> </btn-rating>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    model: Object,
    config: { type: Object, default: {} },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    values: Object,
  },
  data: () => {
    return {
      indicatorChange: false, // индикатор редактирования поля
    };
  },
  computed: {
    money: {
      get() {
        //if (this.indicatorChange) return this.value ?? "";
        if (this.value === null || this.value === undefined || this.value === "") return "";
        return Number(this.value).toLocaleString("ru-RU");
      },
      set(v) {
        let cleaned = String(v)
          .replace(/\s/g, "") // убираем пробелы
          .replace(",", "."); // приводим к точке
        if (!/^\d*\.?\d*$/.test(cleaned)) return;
        const num = cleaned === "" ? null : parseFloat(cleaned);

        this.$emit("input", isNaN(num) ? null : num);
      },
    },
    isDisable() {
      return this.model?.disabled || this.disabled;
    },
    rating: {
      get() {
        let res = this.values.data?.rating?.[this.model.name] || "";
        return res;
      },
      set(v) {
        this.$emit("rating", { name: this.model.name, value: v });
      },
    },
  },
  methods: {
    filter: function (evt) {
      const e = evt || window.event;
      const key = e.key;
      const value = e.target.value;
      const decimalSeparator = (1.1).toLocaleString("ru-RU").substring(1, 2);
      // цифры — всегда ок
      if (/^\d$/.test(key)) return true;
      // если нажали . или ,
      if (key === "." || key === ",") {
        // если уже есть десятичный разделитель — запрещаем
        if (value.includes(decimalSeparator)) {
          e.preventDefault();
          return false;
        }
        // если разделитель другой — подменяем
        if (key !== decimalSeparator) {
          e.preventDefault();
          e.target.value += decimalSeparator;
          return false;
        }
        return true;
      }
      // всё остальное запрещаем
      e.preventDefault();
      return false;
    },
  },
};
</script>
